import React from 'react'
import {useTranslation} from 'react-i18next'
import {ActivationCounters} from '../../domain/entities/Activation.ts'
import {formatNumber} from '../../utils/formatNumber.ts'

// Pack header: disponibles · asignados · activados · caducan en 30 días · caducados y devueltos.
export const ActivationCountersBar: React.FC<{counters: ActivationCounters; onOpenNotActivated?: () => void}> = ({counters, onOpenNotActivated}) => {
    const {t} = useTranslation('dashboard')
    const items: {key: keyof ActivationCounters; tone?: string}[] = [
        {key: 'available'},
        {key: 'assigned'},
        {key: 'activated', tone: 'text-[#12734A]'},
        {key: 'expiringIn30d', tone: counters.expiringIn30d > 0 ? 'text-orange-700' : undefined},
        {key: 'expiredReturned'},
    ]
    return (
        <div className="w-full flex items-center gap-x-5 gap-y-2 flex-wrap pt-3 mt-1 border-t border-[#18AE60]/[.18]">
            <dl className="flex items-center gap-x-5 gap-y-2 flex-wrap flex-1 min-w-0">
                {items.map(({key, tone}) => (
                    <div key={key} className="flex items-baseline gap-1.5">
                        <dt className="text-[12.5px] text-neutralBlack-600">{t(`activation.counters.${key}`)}</dt>
                        <dd className={`text-[15px] font-semibold ${tone ?? 'text-neutralBlack-900'}`}>{formatNumber(counters[key])}</dd>
                    </div>
                ))}
            </dl>
            {onOpenNotActivated && (
                <button type="button" onClick={onOpenNotActivated}
                        className="h-8 px-3.5 rounded-full border border-neutralBlack-300 bg-white text-[12.5px] font-semibold text-neutralBlack-900 hover:bg-neutralBlack-100 whitespace-nowrap">
                    {t('activation.counters.viewNotActivated')}
                </button>
            )}
        </div>
    )
}
